import React from "react";
import { IconProps } from "../constants/GlobalTypesAndEnumsAndConstants";
import { colors, lightColorWithDarkTheme } from "../constants/GlobalStyles";

const IconClose = (props: IconProps) => (
  <svg
    width={props.width || 14}
    height={props.height || 14}
    viewBox="0 0 14 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M14 1.41L12.59 0L7 5.59L1.41 0L0 1.41L5.59 7L0 12.59L1.41 14L7 8.41L12.59 14L14 12.59L8.41 7L14 1.41Z"
      fill={props.color || lightColorWithDarkTheme("#525151", colors.text.body)}
    />
  </svg>
);

export default IconClose;
